import { zSchema } from "../../schema-validation";

export const simpleOdoIdSchema = zSchema.object({
  odo_user_id: zSchema.string(),
});
